var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    ref: "validator",
    attrs: { rules: "required|phoneNumber", slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ errors, classes }) {
          return [
            _c("div", [
              _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.content,
                      expression: "content"
                    }
                  ],
                  staticClass: "form-control",
                  class: classes,
                  attrs: {
                    "data-cy": "phoneInput",
                    required: _vm.required,
                    name: "phoneNumber",
                    readonly: _vm.readonly,
                    type: "text"
                  },
                  domProps: { value: _vm.content },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) return
                        _vm.content = $event.target.value
                      },
                      _vm.onChange
                    ],
                    change: _vm.onChange,
                    blur: _vm.onChange
                  }
                }),
                _vm._v(" "),
                _vm.showErrorIcon(errors)
                  ? _c("i", {
                      staticClass:
                        "fa fa-times text-danger phone-validation-icon",
                      attrs: { title: _vm.$t("INPUT_PHONE_NUMBER.INVALID") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showCheckIcon(errors)
                  ? _c("i", {
                      staticClass:
                        "fa fa-check text-success phone-validation-icon",
                      attrs: { title: _vm.$t("INPUT_PHONE_NUMBER.VALID") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showWarnIcon
                  ? _c("i", {
                      staticClass:
                        "fa fa-warning text-danger phone-validation-icon",
                      attrs: {
                        title: _vm.$t("INPUT_PHONE_NUMBER.VALIDATE_FAILURE")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                errors.length > 0
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v("\n        " + _vm._s(errors[0]) + "\n      ")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.required
                ? _c("label", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "REQUIRED",
                        expression: "'REQUIRED'"
                      }
                    ],
                    staticClass:
                      "col-sm-3 col-md-3 form-group__label-required-manual",
                    class: classes
                  })
                : _vm._e()
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }